import axios from "axios";

const GetBranchList = async () => {
  return axios.get(`BankDetails/GetAllBranch`).then((response) => response);
};


const AddBranch = async (payload) => {
  const config = {
    method: "post",
    url: `BankDetails/AddBranch`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  return axios.request(config).then((response) => response);
};

const UpdateBranch = async (payload) => {
  const config = {
    method: "post",
    url: `BankDetails/UpdateBranch`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  return axios.request(config).then((response) => response);
};

const branchService = {
  GetBranchList,
  AddBranch,
  UpdateBranch
};

export default branchService;
